import app from 'flarum/forum/app';
import Modal from 'flarum/common/components/Modal';
import Button from 'flarum/common/components/Button';
import Stream from "flarum/common/utils/Stream";

export default class AddSiteLevelModal extends Modal {
  static readonly isDismissibleViaBackdropClick = false;
  private params: Array = []

  oninit(vnode) {
    super.oninit(vnode);

    this.attrs.list.map((value, index) => {
      let data = {
        'siteId': Stream(this.attrs.siteId)
      };
      Object.keys(value.attributes).map(item => {
        data[item] = Stream(value.attributes[item]);
      })
      // this.params[index]['siteId'] = Stream(this.attrs.siteId);
      this.params.push(data);
    })

    if (this.params.length == 0) {
      this.addRow(0);
    }

  }

  title() {
    return this.params.siteId ? app.translator.trans('mattoid-pt-site-information.forum.add-site') : app.translator.trans('mattoid-pt-site-information.forum.edit-site');
  }

  className(): string {
    return '';
  }

  content() {
    return (
      <div className="Modal-body">
        <div className="Form">
          <div id="addSite" className="Form-group">
            {
              this.params.map((value, index) => {
                return (
                  <div className="frame">
                    <div className="row">
                      <div className="col-md-4">
                        <label className="Site-Label">{app.translator.trans("mattoid-pt-site-information.forum.level.level")}</label>
                        <input required
                               class="FormControl"
                               type="text"
                               step="1"
                               min="0"
                               style=""
                               bidi={value.level}/>
                      </div>
                      <div className="col-md-4">
                        <label className="Site-Label">{app.translator.trans("mattoid-pt-site-information.forum.level.download")}</label>
                        <input required
                               class="FormControl"
                               type="text"
                               step="1"
                               min="0"
                               style=""
                               bidi={value.download}/>
                      </div>
                      <div className="col-md-4">
                        <label className="Site-Label">{app.translator.trans("mattoid-pt-site-information.forum.level.upload")}</label>
                        <input
                          class="FormControl"
                          type="text"
                          step="1"
                          min="0"
                          style=""
                          bidi={value.upload}/>
                      </div>
                    </div>

                    <div className="row">
                      <div className="col-md-4">
                        <label className="Site-Label">{app.translator.trans("mattoid-pt-site-information.forum.level.sharing-rate")}</label>
                        <input required
                               class="FormControl"
                               type="text"
                               step="1"
                               min="0"
                               style=""
                               bidi={value.sharingRate}/>
                      </div>
                      <div className="col-md-4">
                        <label className="Site-Label">{app.translator.trans("mattoid-pt-site-information.forum.level.integral")}</label>
                        <input
                               class="FormControl"
                               type="text"
                               step="1"
                               min="0"
                               style=""
                               bidi={value.integral}/>
                      </div>
                      <div className="col-md-4">
                        <label className="Site-Label">{app.translator.trans("mattoid-pt-site-information.forum.level.registration-weeks")}</label>
                        <input
                          class="FormControl"
                          type="text"
                          step="1"
                          min="0"
                          style=""
                          bidi={value.registrationWeeks}/>
                      </div>
                    </div>

                    <div className="row">
                      <div className="col-md-3">
                        <label
                          className="Site-Label">{app.translator.trans("mattoid-pt-site-information.forum.level.sort")}</label>
                        <input
                          class="FormControl"
                          type="text"
                          step="1"
                          min="0"
                          style=""
                          bidi={value.sort}/>
                      </div>
                      <div className="col-md-7">
                        <label
                          className="Site-Label">{app.translator.trans("mattoid-pt-site-information.forum.level.remark")}</label>
                        <input required
                               class="FormControl"
                               type="text"
                               step="1"
                               min="0"
                               style=""
                               bidi={value.remark}/>
                      </div>
                      <div className="col-md-2">
                        <Button
                          className={ index + 1 == this.params.length ? 'Button-Add' : 'hide'}
                          onclick={() => {
                            this.addRow(index);
                          }}
                        >
                          +
                        </Button>
                        <Button
                          className={ index > 0 || this.params.length > 1 ? 'Button-Sub' : 'hide'}
                          onclick={() => {
                            this.subRow(index);
                          }}
                        >
                          -
                        </Button>
                      </div>
                    </div>

                  </div>
                )
              })
            }
            <div className="center margin-top-10">
              {
                Button.component({
                  className: 'Button Button--primary',
                  type: 'submit',
                  loading: this.loading,
                }, app.session.user.attribute('canSiteModerateView') ? this.params.siteId ? app.translator.trans("mattoid-pt-site-information.forum.edit-site") : app.translator.trans("mattoid-pt-site-information.forum.add-site") : app.translator.trans("mattoid-pt-site-information.forum.button"))
              }
            </div>
          </div>
        </div>
      </div>
    )
  }

  addRow(index) {
    this.params.push({
      siteId: Stream(this.attrs.siteId),
      level: Stream(),
      download: Stream(),
      upload: Stream(),
      sharingRate: Stream(),
      integral: Stream(),
      registrationWeeks: Stream(),
      remark: Stream(),
    })
  }

  subRow(index) {
    if (this.params.length <= 1) {
      return;
    }
    this.params.splice(index, 1)
    m.redraw();
  }

  onsubmit(e) {
    e.preventDefault();

    this.loading = true;

    app.request({
      method: 'POST',
      url: app.forum.attribute('apiUrl') + '/pt/site/level',
      body: this.params
    }).then(
      (res) => {
        this.loading = false;
        this.hide();
        m.redraw();
      },
      (result) => {
        this.loading = false;
        this.handleErrors(result);
      });
  }
}
